import React, { useState, useCallback, useEffect } from "react";
import classNames from "classnames";
import { fetchStops } from "../../api";
import Button from "../button/Button";
import RegionCheckbox from "./RegionCheckbox";
import MultiSelect from "./MultiSelect";

const regionSchema = [
    {
        value: "110",
        labelHtml: "Northeastern<br />Ontario",
    },
    {
        value: "107",
        labelHtml: "Superior<br />Country",
    },
    {
        value: "108",
        labelHtml: "Sunset<br />Country",
    },
    {
        value: "106",
        labelHtml: "Algoma<br />Country",
    },
];
export const regionSchemaById = {
    "110": {
        name: "Northeastern Ontario",
    },
    "107": {
        name: "Superior Country",
    },
    "108": {
        name: "Sunset Country",
    },
    "106": {
        name: "Algoma Country",
    },
};

function HeaderSearchByRegion(props) {
    const { tags, onSubmit, closeModal } = props;
    const [totalResults, setTotalResults] = useState(null);
    const [tagIds, setTagIds] = useState([]);
    const [selectedRegionIds, setSelectedRegionIds] = useState([]);
    const handleRegionChange = useCallback(
        event => {
            setSelectedRegionIds(event.target.checked ? [event.target.value] : []);
        },
        [setSelectedRegionIds],
    );
    const handleTagsChange = useCallback(items => {
        setTagIds(items.map(item => item.id));
    }, []);
    const formData = {
        tagIds,
        selectedRegionIds,
    };
    const handleSubmit = event => {
        event.preventDefault();
        onSubmit(formData);
        closeModal();
    };
    const disabled = [...selectedRegionIds, ...tagIds].length === 0;

    //Fetch results
    useEffect(() => {
        const callback = async () => {
            const ids = [...tagIds, ...selectedRegionIds];
            if (ids.length === 0) {
                setTotalResults(null);
                return;
            }
            const data = await fetchStops({ start: 0, limit: 1, tagIds: ids });
            setTotalResults(data?.totalResults ?? 0);
        };
        callback();
    }, [selectedRegionIds, tagIds]);

    return (
        <div className="trpr-fs-region-search">
            <fieldset className="trpr-fs-region-search__fieldset">
                <span className="trpr-fs-region-search__checkbox-group-label">Select Region</span>
                <div className="trpr-fs-region-search__checkbox-group">
                    {regionSchema.map(schema => (
                        <RegionCheckbox
                            key={schema.value}
                            checked={selectedRegionIds.includes(schema.value)}
                            value={schema.value}
                            onChange={handleRegionChange}
                            labelHtml={schema.labelHtml}
                        />
                    ))}
                </div>
            </fieldset>
            <fieldset className="trpr-fs-region-search__multiselect-field">
                <span className="trpr-fs-region-search__multiselect-label">Select Tags</span>
                <MultiSelect onChange={handleTagsChange} placeholder="Search" options={tags} />
            </fieldset>
            <div className="trpr-fs-region-search__footer">
                <p className={classNames("trpr-fs-region-search__footer-copy", { "no-results": totalResults === 0 })}>
                    {totalResults > 0 && `${totalResults} results found.`}
                    {totalResults === 0 && "No results found. Try selecting different tags."}
                </p>
                <Button htmlType="button" type="primary-b" size="48" disabled={disabled} onClick={handleSubmit}>
                    Show stops
                </Button>
            </div>
        </div>
    );
}

export default HeaderSearchByRegion;
